import React from 'react'
import '../Styles/Footer.css'

export default function Footer() {

  return (
    <div className='footer'>
        <div className="footercontainer">
          <div className="logobox footerchild">
            <div className="logocontainer" onClick={()=>{window.location.href = `/`;}}>
              <img src="./images/logo.png" alt="" className="footerlogo" />
              <p className="logoboxname"> <span className='footerbigsize'>MAHARISHI DAYANAND</span> <br/> COLLEGE OF EDUCATION</p>
              <p className="logoboxaddress">Gram Baduli, Kolki Railway over Bridge(6 Km from Gagalhedi), Mujaffarnagar Road, <br/> Saharanpur - 247001</p>
            </div>
          </div>
          <div className="footercontact footerchild">
            <div className="footerhead">Contact Details</div>
            <div className="contactcontainer">
            <a className='contactchild' href="tel:+919085888555"><i className="contacticon fa-solid fa-phone"></i>91-9085888555</a> <br/>
            <a className='contactchild' href="tel:+919627793555"><i className="contacticon fa-solid fa-phone"></i>91-9627793555</a> <br/>
            <a className='contactchild' href="tel:+919355789786"><i className="contacticon fa-solid fa-phone"></i>91-9355789786</a> <br/>
            <a className='contactchild' href="tel:+919627793111"><i className="contacticon fa-solid fa-phone"></i>91-9627793111</a> <br/>
            <a className='contactchild' href="tel:+919627793222"><i className="contacticon fa-solid fa-phone"></i>91-9627793222</a> <br/>
            <a className='contactchildmail contactchild' href="mailto:mdcollegesaharanpur@gmail.com"><i className="contacticon fa-solid fa-envelope"></i>mdcollegesaharanpur@gmail.com</a> <br/>

            </div>
            <div className="contactsocialmedia">
              <a href="/contact" rel="noreferrer" target="_blank"><i className="contactsocialicon fa-brands footerfacebook fa-facebook"></i></a>
              <a href="/contact" rel="noreferrer" target="_blank"><i className="contactsocialicon fa-brands footerlinkedin fa-linkedin-in"></i></a>
              <a href="/contact" rel="noreferrer" target="_blank"><i className="contactsocialicon fa-brands footerinstagram fa-instagram"></i></a>
              <a href="/contact" rel="noreferrer" target="_blank"><i className="contactsocialicon fa-brands footertwitter fa-twitter"></i></a>
            </div>
          </div>
          <div className="quicklinks footerchild">
            <div className="footerhead">Useful Links</div>
            <div className="linkscontainer">
              <a href="/thoughts">Chairman Thoughts</a>
              <a href="/gallery">Gallery</a>
              <a href="/vision">Visionary Management</a>
              <a href="/facilities">Facilities</a>
              <a href="/about">Why MD ?</a>
              <a href="/testimonial">Testimonials</a>
            </div>
          </div>
          <div className="quicklinks footerchild">
            <div className="footerhead">Quick Links</div>
            <div className="linkscontainer">
              <a href="/courses">Programs</a>
              <a href="/admission">Admissions</a>
              <a href="/courses">Courses</a>
              <a href="/gallery">Life @ MD</a>
              <a href="/gallery">Campus</a>
              <a href="/contact">FAQ</a>
            </div>
          </div>
        </div>
    </div>
  )
}
